/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserEventExpirationUpdateRequest
 */
export interface UserEventExpirationUpdateRequest {
    /**
     * 
     * @type {any}
     * @memberof UserEventExpirationUpdateRequest
     */
    translationResourceKey?: any | null;
    /**
     * 
     * @type {any}
     * @memberof UserEventExpirationUpdateRequest
     */
    expiryInDays?: any | null;
}

/**
 * Check if a given object implements the UserEventExpirationUpdateRequest interface.
 */
export function instanceOfUserEventExpirationUpdateRequest(value: object): value is UserEventExpirationUpdateRequest {
    return true;
}

export function UserEventExpirationUpdateRequestFromJSON(json: any): UserEventExpirationUpdateRequest {
    return UserEventExpirationUpdateRequestFromJSONTyped(json, false);
}

export function UserEventExpirationUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEventExpirationUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'translationResourceKey': json['translationResourceKey'] === undefined ? undefined : json['translationResourceKey'] === null ? null : json['translationResourceKey'],
        'expiryInDays': json['expiryInDays'] === undefined ? undefined : json['expiryInDays'] === null ? null : json['expiryInDays'],
    };
}

export function UserEventExpirationUpdateRequestToJSON(json: any): UserEventExpirationUpdateRequest {
    return UserEventExpirationUpdateRequestToJSONTyped(json, false);
}

export function UserEventExpirationUpdateRequestToJSONTyped(value?: UserEventExpirationUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'translationResourceKey': value['translationResourceKey'],
        'expiryInDays': value['expiryInDays'],
    };
}

